import React, { useState, useRef } from "react";
import SignupForm from "./SignupForm";
import setAuthorization from "../utilities/setAuthorization";
import makeRequest from "../utilities/makeRequest";

const SignupContainer = ({
  closeModalAfterAuthentication,
  errors,
  login,
  setErrors,
}) => {
  const checkButton = useRef();
  const form = useRef();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [username, setUsername] = useState("");

  const onChangeUsername = (event) => {
    setUsername(event.target.value);
  };

  const onChangeEmail = (event) => {
    setEmail(event.target.value);
  };

  const onChangePassword = (event) => {
    setPassword(event.target.value);
  };

  const onChangePasswordConfirmation = (event) => {
    setPasswordConfirmation(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    form.current.validateAll();

    if (checkButton.current.context._errors.length === 0) {
      const url = `${process.env.REACT_APP_HOST}/api/v1/users/register`;
      const verb = "POST";
      const headers = new Headers({ "Content-Type": "application/json" });

      const body = JSON.stringify({
        user: {
          username: username,
          email: email,
          password: password,
          password_confirmation: passwordConfirmation,
        },
      });

      makeRequest(url, verb, body, headers)
        .then((response) => {
          setAuthorization(
            closeModalAfterAuthentication,
            login,
            response,
            setErrors,
            "signup"
          );
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  return (
    <SignupForm
      checkButton={checkButton}
      closeModal={closeModalAfterAuthentication}
      email={email}
      errors={errors}
      form={form}
      handleSubmit={handleSubmit}
      onChangeEmail={onChangeEmail}
      onChangePassword={onChangePassword}
      onChangePasswordConfirmation={onChangePasswordConfirmation}
      onChangeUsername={onChangeUsername}
      password={password}
      passwordConfirmation={passwordConfirmation}
      setErrors={setErrors}
      username={username}
    />
  );
};

export default SignupContainer;
